<template>
  <div class="union-chapter">
    <el-row :gutter="20">
      <el-col :span="17">
        <div class="chapter-title">
          <h3>{{chapterObj.title}}</h3>
        </div>
        <p v-html="chapterObj.text" class="chapter-text"></p>
      </el-col>
      <el-col :span="7">
        <ul>
          <li v-for="(item,index) in chapters" :key="index" @click="getChapter(index)" class="ch_item" :class="{ activeStyle:activeIndex==index }">
            <div class="ch-con">
              <img v-show="item.isB" :src="item.pathB" width="24" height="24" alt="">
              <img v-show="item.isW" :src="item.pathW" width="24" height="24" alt="">
            </div>
            <div class="ch-con">&nbsp;&nbsp;&nbsp;&nbsp;{{item.title}}</div>
          </li>
        </ul>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { homeCommonData } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      activeIndex: 0,
      chapters: [],
      chapterObj: {
        title: '',
        text: ''
      },
      ch_icons: [
        {
          pathB: '../../../../static/img/summary/doc.png',
          pathW: '../../../../static/img/summary/module/doc.png',
          isB: true,
          isW: false
        },
        {
          pathB: '../../../../static/img/summary/org.png',
          pathW: '../../../../static/img/summary/module/org.png',
          isB: true,
          isW: false
        },
        {
          pathB: '../../../../static/img/summary/member.png',
          pathW: '../../../../static/img/summary/module/member.png',
          isB: true,
          isW: false
        },
        {
          pathB: '../../../../static/img/summary/guanli.png',
          pathW: '../../../../static/img/summary/module/guanli.png',
          isB: true,
          isW: false
        },
        {
          pathB: '../../../../static/img/summary/know.png',
          pathW: '../../../../static/img/summary/module/know.png',
          isB: true,
          isW: false
        },
        {
          pathB: '../../../../static/img/summary/ctl.png',
          pathW: '../../../../static/img/summary/module/ctl.png',
          isB: true,
          isW: false
        }
      ]
    };
  },
  created() {
    // commonType=9 联盟章程
    this.initChapter(9);
  },
  methods: {
    initChapter(textNo) {
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: textNo }).then(
        res => {
          let tempArray = res.data.records;
          for (let i = 0; i < tempArray.length; i++) {
            let tempObj = { title: '', text: '' };
            tempObj.title = tempArray[i].commonName;
            tempObj.text = tempArray[i].commonText;
            tempObj.pathB = this.ch_icons[i].pathB;
            tempObj.pathW = this.ch_icons[i].pathW;
            tempObj.isB = this.ch_icons[i].isB;
            tempObj.isW = this.ch_icons[i].isW;
            this.chapters.push(tempObj);
          }
          this.getChapter(0);
        }
      );
    },
    getChapter(index) {
      this.activeIndex = index;
      for (let i = 0; i < this.chapters.length; i++) {
        if (index === i) {
          this.chapters[i].isB = false;
          this.chapters[i].isW = true;
        } else {
          this.chapters[i].isB = true;
          this.chapters[i].isW = false;
        }
      }
      this.chapterObj.title = this.chapters[index].title;
      this.chapterObj.text = this.chapters[index].text;
    },
    firstView() {
      this.chapterObj.title = this.chapters[0].title;
      this.chapterObj.text = this.chapters[0].text;
    }
  }
};
</script>
<style lang="stylus" scoped>
.chapterList {
  width: 100%;
  overflow: hidden;
  margin-bottom: 10px;
  border: 1px solid red;
}

.union-chapter {
  width: 100%;
  margin: 0 auto;

  .chapter-title {
    width: 100%;
    text-align: center;
  }

  .chapter-text {
    text-indent: 2em;
    line-height: 28px;
    font-size: 14px;
  }

  .ch-con {
    float: left;
  }
}

.ch_item {
  min-width: 276px;
}

ul li {
  height: 40px;
  line-height: 40px;
  border: 1px solid #DCDCDC;
  margin-bottom: 10px;
  width: 90%;
  padding-left: 20px;
  cursor: pointer;
}

ul li:hover {
  color: #8a8a8a;
  background-color: #DCDCDC;
  border: 1px solid #DCDCDC;
}

.activeStyle {
  background-color: #409EFF;
  color: #fff;
  border: 1px solid #409EFF;
}

img {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/overview/unionChapter.vue